import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import formatPhoneNumber from "../utils/formatPhoneNumber";
import { useParams, useNavigate } from "react-router-dom";
import { DatePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const UserSolutionCoachForm = ({ user }) => {
  const [updatedUser, setUpdatedUser] = useState({
    name: user.name || "",
    profile_image_url: user.profile_image_url || "",
    intro_video_url: user.intro_video_url || "",  
  });
  const [selectedFiles, setSelectedFiles] = useState({});
  const [videoKey, setVideoKey] = useState(Date.now());

  const [errors, setErrors] = useState({});
  const [isEdited, setIsEdited] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hasChanges = Object.keys(updatedUser).some(
      (key) => updatedUser[key] !== user[key]
    );
    setIsEdited(hasChanges);
  }, [updatedUser, user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedUser({
      ...updatedUser,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      const file = files[0];
      setSelectedFiles((prev) => ({ ...prev, [name]: file }));
      const fileURL = URL.createObjectURL(file);
      if (name === "intro_video_url") {
        setVideoKey(Date.now());
      }
      setUpdatedUser((prevUser) => ({
        ...prevUser,
        [name]: fileURL,
      }));
      setIsEdited(true);
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    try {
      if (!isEdited) {
        toast.info("No changes detected. Please update user profile before saving.");
        return;
      }
  
      if (!isSaved) {
        const formData = new FormData();
        formData.append("name", updatedUser.name);
        if (selectedFiles.profile_image_url) {
          formData.append("image", selectedFiles.profile_image_url);
        }
        if (selectedFiles.intro_video_url) {
          formData.append("video", selectedFiles.intro_video_url);
        }
        formData.append("dob", new Date().toISOString());
  
        const request = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/solution-coach/update-solution-coach/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (request.data.success) {
          toast.success(request.data.message);
          setIsSaved(true);
          setTimeout(() => {
            navigate("/solution-coach");
          }, 3000);
        } else {
          toast.error(request.data.message);
        }
      }
    } catch (error) {
      console.log(error, "error");
      toast.error("Network connection lost. Please check your connection and try again.");
    }
  };
  

  return (
    <div style={styles.container}>
      <ToastContainer />
      <div style={styles.header}>
        <h2 style={styles.title}>Update User Profile</h2>
        <div style={styles.buttonContainer}>
          <button 
            style={styles.editButton} 
            onClick={onSave} 
          >
            Save
          </button>
        </div>
      </div>
      <div style={styles.infoContainer}>
        <div style={styles.infoRow}>
          <span style={styles.span}>Name</span>
          <input
            type="text"
            name="name"
            className="form-control w-50"
            value={updatedUser.name}
            onChange={handleInputChange}
            style={styles.input}
          />
        </div>

        <div style={styles.infoRow}>
          <span style={styles.span}>Profile Image</span>
          {updatedUser.profile_image_url ? (
            <img src={updatedUser.profile_image_url}  alt="Profile" style={styles.image} />
          ) : (
            <span>No Image Available</span>
          )}
          <input type="file" name="profile_image_url" accept="image/*" onChange={handleFileChange} />
        </div>

        <div style={styles.infoRow}>
          <span style={styles.span}>Intro Video</span>
          {updatedUser.intro_video_url ? (
            <video key={videoKey} controls style={styles.video}>
              <source src={updatedUser.intro_video_url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <span>No Video Available</span>
          )}
          <input type="file" name="intro_video_url" accept="video/mp4,video/x-m4v,video/*" onChange={handleFileChange} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "1000px",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "#fff",
    fontFamily: "Poppins",
  },
  header: {
    backgroundColor: "#064260",
    padding: "20px 35px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 600,
  },
  infoContainer: {
    padding: "0",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 35px",
    borderBottom: "1px solid #eee",
    fontSize: "1em",
    alignItems: "center",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
  },
  image: {
    width: '100px',
    height: '100px',
    borderRadius: '50rem',
  },
  video: {
    width: '200px',
    height: '150px',
    borderRadius: '8px',
  },
  editButton: {
    backgroundColor: "#27B99A",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
};

export default UserSolutionCoachForm;